import { render, staticRenderFns } from "./choicePackingWork.vue?vue&type=template&id=12ca00fb&scoped=true"
import script from "./choicePackingWork.vue?vue&type=script&lang=js"
export * from "./choicePackingWork.vue?vue&type=script&lang=js"
import style0 from "./choicePackingWork.vue?vue&type=style&index=0&id=12ca00fb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ca00fb",
  null
  
)

export default component.exports